(function () {
    'use strict';

    angular
        .module('app')
        .controller('GiftCardCheckoutCompleteController', GiftCardCheckoutCompleteController);

        GiftCardCheckoutCompleteController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies', 'authenticator'];

    function GiftCardCheckoutCompleteController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies, authenticator) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;

        function init() {
            if(!$stateParams.checkout_id){
                close();
            }
            vm.isLight = authenticator.isLight();
            getGiftCard().then(function() {
                if(vm.isLight) {
                    vm.wasLight = true;
                    vm.user_email = $cookies.get('_user_email_');
                    authenticator.logout();
                    getUserStatus();
                }
            });;
        }

        function getUserStatus() {
            $http.post('/app/api/user/get/', {user_email: vm.user_email})
                .then(function (response) {
                    vm.has_user = !response.data.is_light;
                });
        }

        function getGiftCard() {

            return $http.get('/app/api/checkout_gift_card/' + $stateParams.checkout_id)
                .then(function (response) {
                    vm.giftCardLoaded = true;
                    vm.giftCardAmount = response.data.amount / 100;
                    vm.giftCardCode = response.data.code;
                    vm.giftCardExpirationDate = response.data.expiration_date;
                    vm.giftCardCurrency = response.data.currency;
                    vm.giftCardLinkEn = response.data.gift_card_link_en;
                    vm.giftCardLinkDa = response.data.gift_card_link_da;
                    if($stateParams.language == 'da'){
                        vm.mailtoLink = "mailto:" + "" + 
                                    "?subject=" + "Be My Concert gavekort" +
                                    "&body=" + "Hej, %0D%0A %0D%0A" + 
                                               "Jeg sender dig her et gavekort som du kan bruge til at købe koncertbilletter på bemyconcert.com. %0D%0A %0D%0A" +
                                               "Her er linket til gavekortet og vejledning til hvordan du indløser det. %0D%0A" +
                                               vm.giftCardLinkDa + " %0D%0A %0D%0A" +
                                               "Be My Concert Gavekort beløb: " + vm.giftCardAmount + " " + vm.giftCardCurrency + "%0D%0A" +
                                               "Kode: " + vm.giftCardCode + " %0D%0A %0D%0A" +
                                               "God fornøjelse!";
                    } else if ($stateParams.language == 'en') {
                        vm.mailtoLink = "mailto:" + "" + 
                                    "?subject=" + "Be My Concert Gift Card" +
                                    "&body=" + "Hi, %0D%0A %0D%0A" + 
                                               "I am sending you a gift card that you can use to buy concert tickets on bemyconcert.com. %0D%0A %0D%0A" +
                                               "Here is a link to the gift card and instructions on how to redeem it. %0D%0A" +
                                               vm.giftCardLinkEn + " %0D%0A %0D%0A" +
                                               "Be My Concert Gift Card Amount: " + vm.giftCardAmount + " " + vm.giftCardCurrency + "%0D%0A" +
                                               "Code: " + vm.giftCardCode + " %0D%0A %0D%0A" +
                                               "Enjoy!";
                    }
                    
                });
        }

        function close() {
            return $state.go('frontpage');
        }

    }
})();